/**
 * FB5999a8a85a：移交阶段就近维护许可证编号，避免用户离开阶段页去设置中查找。
 * 复用项目 permitNumbers 字段、项目编辑权限及 PATCH 接口；不代替移交校验，
 * 也不另写工程数据，工程侧编号仍由现有移交流程同步。
 */
import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../../components/ui/button";
import { T } from "../../../lib/i18n";

export const HandoffPermitField = ({ project, canEdit, api, onSaved }) => {
  const current = project?.permitNumbers || "";
  const [value, setValue] = useState(current);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const saving = useRef(false);
  // 只在服务端编号或项目发生变化时同步，不让其他资料刷新覆盖用户尚未保存的输入。
  useEffect(() => { setValue(current); setError(""); setSaved(false); }, [project?.id, current]);

  const save = async () => {
    if (!canEdit || saving.current || !project?.id || value.trim() === current.trim()) return;
    saving.current = true;
    setBusy(true); setError(""); setSaved(false);
    try {
      await api.patch(`/design/v3/projects/${project.id}`, { permitNumbers: value.trim() });
      setSaved(true);
      onSaved?.();
    } catch (e) {
      setError(e?.response?.data?.detail || e?.message || T("保存失败，请重试"));
    } finally { saving.current = false; setBusy(false); }
  };

  return <div className="space-y-2 rounded-lg border border-slate-200 p-3" data-testid="dv3-handoff-permit">
    <label className="block text-xs text-slate-600">
      {T("Permit / Case 编号")}
      {canEdit ? <input value={value} disabled={busy} data-testid="dv3-handoff-permit-input"
        onChange={(e) => { setValue(e.target.value); setSaved(false); }}
        className="mt-1 w-full rounded-md border border-slate-200 px-2.5 py-1.5 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 disabled:opacity-50" />
        : <span className="mt-1 block text-sm" data-testid="dv3-handoff-permit-value">{current || T("未填写")}</span>}
    </label>
    {canEdit && <Button type="button" size="sm" variant="outline" onClick={save}
      disabled={busy || value.trim() === current.trim()} data-testid="dv3-handoff-permit-save">
      {busy ? T("保存中…") : T("保存编号")}
    </Button>}
    {error && <p role="alert" className="text-xs text-red-600">{String(error)}</p>}
    {saved && <p role="status" className="text-xs text-emerald-700">{T("编号已保存")}</p>}
  </div>;
};
